/** Тексты окна: Выбор языка. */
import type { MessageBundle } from "../../../i18n";

const en = {
  "win.language.title": "Language",
  "win.language.close": "Not now",
} as const;

type Key = keyof typeof en;

const ru: Record<Key, string> = {
  "win.language.title": "Язык",
  "win.language.close": "Не сейчас",
};

const uk: Record<Key, string> = {
  "win.language.title": "Мова",
  "win.language.close": "Не зараз",
};

export const messages: MessageBundle<Key> = { en, ru, uk };
